import React from 'react'
import Tile from '@/shared/components/Tile/Tile'
import LanguageSelect from '@/shared/components/LanguageSelect/LanguageSelect'
import styles from '@/features/auth/Authorization.module.scss'

type AuthorizationProps = {
  children: React.ReactNode
}

function Authorization(props: AuthorizationProps) {
  const { children } = props
  return (
    <div className={`${styles.authorizationFormContainer}`}>
      <Tile color="white">
        <div className={`${styles.authorizationHeader}`}>
          <div id="logo" className={`${styles.logo}`} />
          <LanguageSelect compact />
        </div>
        {children}
      </Tile>
    </div>
  )
}

export default Authorization
